import React, { useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const ImageCarousel = ({ images = [], onImageClick }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true },
    [Autoplay({ delay: 3500, stopOnInteraction: false })]
  );

  useEffect(() => {
    if (emblaApi) emblaApi.reInit();
  }, [emblaApi, images]);

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {images.map((item, idx) => {
            const src = item?.src || item?.img;
            const alt = item?.alt || '';
            return (
              <div className="embla__slide" key={idx}>
                <img
                  src={src}
                  alt={alt}
                  className="embla__card-img"
                  onClick={() => onImageClick && src && onImageClick(src)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;


